export default {
  headers: {
    addTitle: 'REGISTER & RELEASE',
    newInvoice: 'New invoice',
    newSelfInvoice: 'New SelfInvoice',
    proForm: 'Proforma',
    import: 'Import',
    pendingInvoices: 'Invoices pending of issue',
    pendingAutoinvoices: 'Autofacturas pending of issue',
    newThirdParty: 'New supplied & third',
    pendingThirdParty: 'Supplied & third pending of issue',
    searcher: 'Searcher',
    searcherOld: 'Search old',
    emittedTitle: 'EMITTED/RECEIVED',
    provider: 'Provider',
    payer: 'Payer',
    financing: 'Financing',
    configTitle: 'CONFIGURATION',
    generalData: 'General data',
    notification: 'Alerts',
    keys: 'Keys',
    catalog: 'Catalogue',
    format: 'Invioce format',
    agenda: 'AGENDA',
    stats: 'STATS',
    thirdParty: 'Third Party',
    thirdPartyWithoutIssued: 'Supplied & third pending of issue'
  },
  summary: 'Summary'
}
